import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip, Upload, Download, Trash2, Loader2 } from "lucide-react";
import { api, errMsg, downloadFile } from "@/lib/api";

export function RecordFiles({ c, record, locked, onCase, pre }: { c: any; record: any; locked: boolean; onCase: (data: any) => void; pre: string }) {
  const ref = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const files = (c.attachments || []).filter((a: any) => !a.is_deleted && record.id && a.record_id === record.id);
  const upload = async (list: FileList) => {
    setBusy(true);
    for (const file of Array.from(list)) {
      const fd = new FormData();
      fd.append("file", file);
      try { onCase((await api.post(`/admin/cases/${c.id}/attachments`, fd, { params: { record_id: record.id } })).data); toast.success(`${file.name} attached`); }
      catch (e) { toast.error(errMsg(e)); }
    }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };
  const remove = async (id: string) => {
    try { onCase((await api.delete(`/admin/cases/${c.id}/attachments/${id}`)).data); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-xl border border-dashed border-slate-300 bg-[#FAFAF7] p-3" data-testid={`${pre}-files`}>
      <p className="mb-2 text-xs font-bold uppercase tracking-wide text-[#64748B]">Court documents for this case</p>
      {files.map((a: any) => (
        <div key={a.id} className="mb-1.5 flex items-center gap-2 text-sm" data-testid={`${pre}-file-${a.id}`}>
          <Paperclip className="h-4 w-4 text-[#1B365D]" /><span className="min-w-0 flex-1 truncate">{a.filename}</span>
          <button type="button" className="text-[#1B365D]" onClick={() => downloadFile(`/admin/cases/${c.id}/attachments/${a.id}`, a.filename)} data-testid={`${pre}-file-download-${a.id}`}><Download className="h-4 w-4" /></button>
          {!locked && <button type="button" className="text-[#B91C1C]" onClick={() => remove(a.id)} data-testid={`${pre}-file-remove-${a.id}`}><Trash2 className="h-4 w-4" /></button>}
        </div>
      ))}
      {!record.id ? <p className="text-xs text-[#94A3B8]">Save records first, then upload court documents for this case.</p> : !locked && (
        <>
          <input ref={ref} type="file" multiple accept="application/pdf,image/png,image/jpeg" className="hidden" onChange={(e) => e.target.files?.length && upload(e.target.files)} data-testid={`${pre}-file-input`} />
          <button type="button" className="btn-secondary btn-sm" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${pre}-file-upload-button`}>
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} Upload PDF / images
          </button>
        </>
      )}
    </div>
  );
}
